module.exports = __webpack_public_path__ + "static/media/default.d531bfa5.png";